import React, { Component } from 'react'
import { connect } from 'react-redux'
import { heatSelect } from '~/store/actions/heat'
import { isLiveChanged } from '~/store/actions/is-live'
import PropTypes from 'prop-types'
import TabSwitcher from '~/views/Home/base/TabSwitcher'
import Scrollable from '~/views/Home/base/Scrollable'
import { translate } from '~/decorators'
import oget from 'oget'
import isEqual from 'lodash.isequal'
import defaultPropTypes from './default-prop-types'
import StartListRow from './row'
import SizeInformer from '~/views/Home/base/SizeInformer'
import './index.scss'

export default @translate(
  'home.table.start-list'
)
@connect(
  null,
  dispatch => ({
    onHeatSelect: (...args) => dispatch(
      heatSelect(...args)
    ),
    onIsLiveChanged: (...args) => dispatch(
      isLiveChanged(...args)
    )
  })
)
class TableStartList extends Component {
  state = {
    activeExternalAthleteId: null,
    scrollToTop: false,
    scrollToLive: false,
    hasScrollbar: false,
    tabsHeight: null,
    startList: [],
    showExtraForAthleteId: null
  }

  static propTypes = {
    event: PropTypes.shape({
      startListColumns: PropTypes.object,
      leaderboardColumns: PropTypes.object
    }).isRequired,
    round: PropTypes.oneOfType([
      item => item === null,
      PropTypes.object.isRequired
    ]),
    roundActive: PropTypes.any,
    roundState: PropTypes.any,
    heats: PropTypes.array.isRequired,
    heatsById: PropTypes.object.isRequired,
    heatId: PropTypes.any,
    athletes: PropTypes.shape({
      expectedHeatId: PropTypes.any,
      byId: PropTypes.object,
      isLiveId: PropTypes.any
    }).isRequired,
    isLive: PropTypes.shape({
      athleteId: PropTypes.any,
      heatId: PropTypes.any,
      changed: PropTypes.bool
    }).isRequired,
    ...defaultPropTypes
  }

  static getDerivedStateFromProps (
    {
      isLive,
      heatsById,
      heatId,
      round
    },
    {
      activeExternalAthleteId: prevActiveExternalAthleteId,
      startList: prevStartList,
      round: prevRound
    }
  ) {
    const activeExternalAthleteId = isLive.athleteId

    const roundConfig = {
      autoFocus: oget(round, 'autofocus') !== false
    }

    const startList = oget(
      heatsById,
      `[${heatId}].startList`,
      []
    )

    if (!isEqual(prevStartList, startList)) {
      return {
        startList,
        roundConfig,
        scrollToTop: true,
        scrollToLive: true
      }
    }

    if (!activeExternalAthleteId) {
      return {
        startList,
        roundConfig
      }
    }

    if (activeExternalAthleteId === prevActiveExternalAthleteId) {
      return {
        startList,
        roundConfig
      }
    }

    return {
      startList,
      roundConfig,
      activeExternalAthleteId,
      scrollToLive: true
    }
  }

  removeRefs = () => {
    this.containerDiv = null
    this.scrollDiv = null
    this.isLiveDiv = null
    this.tabsSwitcher = null
  }

  componentWillUnmount = () => this.removeRefs()

  componentDidUpdate () {
    const {
      scrollToLive,
      scrollToTop,
      roundConfig: {
        autoFocus
      }
    } = this.state

    if (!this.scrollDiv) {
      return
    }

    if (!autoFocus && scrollToTop) {
      this.scrollDiv.scrollTop = 0

      this.setState({
        scrollToTop: false
      })
    }

    if (autoFocus && scrollToLive) {
      this.scrollDiv.scrollTop = this.isLiveDiv
        ? this.isLiveDiv.offsetTop
        : 0

      this.setState({
        scrollToLive: false,
        scrollToTop: false
      })
    }

    const {
      isLive,
      heatsById,
      onIsLiveChanged,
      onHeatSelect
    } = this.props

    if (!isLive.changed && isLive.heatId) {
      onIsLiveChanged()

      onHeatSelect(
        heatsById[isLive.heatId]
      )
    }
  }

  onScrollableUpdate = ({ hasScrollbar }) => this.setState({
    hasScrollbar
  })

  toggleExtra = (externalAthleteId) => {
    const { showExtraForAthleteId } = this.state

    this.setState({
      showExtraForAthleteId: showExtraForAthleteId === externalAthleteId
        ? null
        : externalAthleteId
    })
  }

  lastResizeDate = new Date(0)
  lastWidth = 0

  updateLastResizeDate = () => {
    if (!this.containerDiv) {
      return
    }

    const style = window.getComputedStyle(
      this.containerDiv.parentNode
    )

    const width = parseInt(
      style.width, 10
    )

    if (width !== this.lastWidth) {
      this.lastWidth = width
      this.lastResizeDate = new Date()
    }
  }

  className = () => {
    const { heats } = this.props
    const { hasScrollbar } = this.state

    this.updateLastResizeDate()

    return [
      'table-start-list',
      hasScrollbar
        ? 'has-scrollbar'
        : '',
      heats.length > 1
        ? 'has-tabs'
        : ''
    ].join(' ')
  }

  render () {
    const {
      t,
      athletes,
      heats,
      heatId,
      roundActive,
      onHeatSelect,
      colors,
      event: {
        startListColumns
      }
    } = this.props

    const {
      startList,
      showExtraForAthleteId,
      tabsHeight
    } = this.state

    const hasTabs = heats.length > 1
    const showGroupTitle = startList.length > 1

    return (
      <div
        className={this.className()}
        ref={ref => this.containerDiv = ref}
      >
        <div className="table-title">
          {t('Start List')}
        </div>

        {hasTabs &&
        <SizeInformer
          lastUpdate={this.lastResizeDate}
          onResized={({ height }) => {
              if (this.state.tabsHeight !== height) {
                  this.setState({
                      tabsHeight: height
                  })
              }
          }}
        >
          <TabSwitcher
            ref={(ref) => {
              if (this.tabsSwitcher) {
                this.lastResizeDate = new Date()
              }

              this.tabsSwitcher = ref
            }}
            tabs={heats}
            renderTab={(heat, i) => {
              let classActive = ''
              let style = {}
              if(heat.externalId === heatId) {
                classActive = 'active'
                style = {
                  backgroundColor: colors.itemActive.backgroundColor
                }
              }
              return (
                <span
                  key={`tartlist_heats_tabs_${i}`}
                  className={classActive}
                  style={style}
                  onClick={() => onHeatSelect(
                    heat
                  )}
                >
                  {heat.name}
                </span>
              )
            }}
          />
        </SizeInformer>
        }

        {!startList.length &&
        <div className="no-info">
          {t('No live information at this time')}
        </div>
        }

        {startList.length > 0 &&
        <div className="head">
          <div className="cell cell-no">
            {t('No')}
          </div>

          {startListColumns.Bib &&
          <div className="cell cell-bib">
            {t('Bib')}
          </div>
          }

          <div className="cell cell-name">
            {t('Name')}

            {startListColumns.Nation &&
            <span> / {t('Nation')}</span>
            }
          </div>
        </div>
        }

        {startList.length > 0 &&
        <Scrollable
          onUpdate={this.onScrollableUpdate}
          onContentRef={ref => this.scrollDiv = ref}
          style={hasTabs
            ? { top: tabsHeight + 47 }
            : {}
          }
        >
          {startList.map((group, i) => (
            <div
              key={`startlist_heat_category_${i}`}
              className="heat-category"
            >
              {showGroupTitle &&
              <div className="category-title">
                {oget(
                  group,
                  '[0].category',
                  ''
                )}
              </div>
              }

              {group.map((item, i) => {
                const athleteExternalId = item.athlete.externalId

                const athlete = athletes.byId[
                  athleteExternalId
                  ] || {}

                return (
                  <StartListRow
                    key={`startlist_row_${i}`}
                    onRef={ref => {
                      if (athlete.isLive) {
                        this.isLiveDiv = ref
                      }
                    }}
                    onClick={() => this.toggleExtra(
                      athleteExternalId
                    )}
                    roundActive={roundActive}
                    showExtraForAthleteId={showExtraForAthleteId}
                    athleteExternalId={athleteExternalId}
                    startListColumns={startListColumns}
                    athlete={athlete}
                    colors={colors}
                    item={item}
                    i={i}
                    t={t}
                  />
                )
              })}
            </div>
          ))}
        </Scrollable>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableStartList/index.js